import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "ControlGLReconciliation" })((_theme) => ({
  page: {
    margin: "20px",
  },
  controlGLReconciliationExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
